
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M10.161 2.687a1.25 1.25 0 011.768 0l.884.884a1.25 1.25 0 010 1.768l-6.769 6.768c-.261.262-.595.44-.958.513l-1.838.368a.625.625 0 01-.736-.736l.368-1.838c.073-.363.251-.697.513-.958l6.768-6.769zm1.768 1.768l-.884-.884-.442.442.884.884.442-.442zm-1.326 1.326l-.884-.884-5.442 5.442a.625.625 0 00-.171.32l-.184.92.92-.185a.625.625 0 00.319-.17l5.442-5.443z"}})])
          )
        }
      }
    